<template>
  <div class="showDemo" v-show="showDemo && demoList.length > 0">
    <div class="demoItem">
      <div class="demoWarn"></div>
      <div class="demoContent" v-for="(item, index) in demoList" :key="index">
        <div class="warnItem">监测点位：{{ item.monitorSiteName }}</div>
        <div class="warnItem">隐患回路：{{ item.branchName }}</div>
        <div class="warnItem">分析：{{ item.alertDescription }}</div>
      </div>
      <div class="demoWarn"></div>
        <div class="demoClose" @click="closeDemo">×</div>
    </div>
  </div>
</template>

<script>
import Axios2 from '@/utils/Axios2';

export default {
  name: 'DemoAlert',
  data() {
    return {
      showDemo: false,
      demoList: [],
      processedAlerts: new Set(), // 本地存储已处理的预警ID
      demoPollTimer: null,
      audioAlert: null,
      audioTimer: null,
      hasPlayedAlert: false,
      deptId: '',
      routeListener: null,
      storageListener: null,
    };
  },
  mounted() {
    // 从本地存储获取部门ID
    this.deptId = Number(localStorage.getItem('deptId'));
    console.log('DemoAlert mounted, deptId:', this.deptId);
    this.checkUserDemo();

    // 监听localStorage变化，重新检查用户是否是demo用户
    this.storageListener = (event) => {
      console.log('LocalStorage changed:', event.key);
      // 当token或userInfo变化时，重新检查
      if (event.key === 'token') {
        let token = localStorage.getItem('deptId');
        if (token) {
          this.deptId = Number(localStorage.getItem('deptId'));
          this.checkUserDemo();
        }
      }
    };
    window.addEventListener('storage', this.storageListener);
  },
  beforeDestroy() {
    this.stopDemoPolling();
    // 清理路由监听器
    if (this.routeListener) {
      this.routeListener();
    }
    // 清理storage监听器
    if (this.storageListener) {
      window.removeEventListener('storage', this.storageListener);
    }
  },
  watch: {
    demoList: {
      immediate: true,
      handler(val) {
        if (val && val.length && !this.hasPlayedAlert) {
          this.hasPlayedAlert = true;
          this.startAlertLoop();
        } else if (!val || val.length === 0) {
          this.hasPlayedAlert = false;
          this.stopAlertLoop();
        }
      },
    },
  },
  methods: {
    startAlertLoop() {
      if (this.audioTimer) return;
      this.audioAlert = new Audio('/audio/alert.mp3');
      this.audioAlert.volume = 0.8;
      this.audioAlert.loop = true;
      this.audioAlert.play().catch(e => console.warn('播放失败:', e));
    },

    stopAlertLoop() {
      if (this.audioAlert) {
        this.audioAlert.pause();
        this.audioAlert.currentTime = 0;
        this.audioAlert = null;
      }
      if (this.audioTimer) {
        clearInterval(this.audioTimer);
        this.audioTimer = null;
      }
    },

    closeDemo() {
      this.showDemo = false;
      this.demoList = [];
      // 不清空已处理的预警ID，下次获取时不再显示
      this.stopAlertLoop();
      this.hasPlayedAlert = false;
    },

    checkUserDemo() {
      console.log('checkUserDemo called, deptId:', this.deptId);
      // 只有当deptId有效时才检查
      if (this.deptId && this.deptId > 0) {
        Axios2.ajax({
          url: 'api/v1/demo/online',
          method: 'GET',
        }).then(res => {
          console.log('checkUserDemo response:', res);
          if (!res.data) return;
          if (res.data === 'true' || res.data === true) {
            this.startDemoPolling();
          } else {
            this.stopDemoPolling();
          }
        }).catch(err => {
          console.error('checkUserDemo error:', err);
          this.stopDemoPolling();
        });
      } else {
        console.log('Invalid deptId, stopping demo polling');
        this.stopDemoPolling();
      }
    },

    startDemoPolling() {
      console.log('startDemoPolling called');
      if (this.demoPollTimer) return;
      this.getDemoList();
      this.showDemo = true;
      this.demoPollTimer = setInterval(() => {
        console.log('Polling...');
        this.getDemoList();
        this.showDemo = true;
      }, 5 * 1000);
      console.log('Demo polling started');
    },

    stopDemoPolling() {
      if (this.demoPollTimer) {
        this.showDemo = false;
        clearInterval(this.demoPollTimer);
        this.demoPollTimer = null;
      }
    },

    getDemoList() {
      console.log('getDemoList called, deptId:', this.deptId);
      Axios2.ajax({
        url: 'api/v1/demo/alertList',
        method: 'GET',
        params: {
          orgId: this.deptId,
        },
      }).then(res => {
        console.log('getDemoList response:', res);
        if (res.data && res.data.length > 0) {
          // 过滤出本地未处理的预警
          const newAlerts = res.data.filter(alert => !this.processedAlerts.has(alert.alertId));
          console.log('New alerts:', newAlerts);
          if (newAlerts.length > 0) {
            this.demoList = newAlerts;
            // 标记为已处理
            newAlerts.forEach(alert => this.processedAlerts.add(alert.alertId));
            console.log('Processed alerts:', this.processedAlerts);
          }
        }
      }).catch(err => {
        console.error('getDemoList error:', err);
      });
    },
  },
};
</script>

<style scoped>
.showDemo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  animation: borderFlash 1.5s infinite;
}

@keyframes borderFlash {
  0%, 100% {
    box-shadow: 0 0 30px rgba(255, 215, 0, 1),
                inset 0 0 30px rgba(255, 215, 0, 1);
  }
  50% {
    box-shadow: 0 0 100px rgba(255, 215, 0, 1),
                inset 0 0 200px rgba(255, 215, 0, 1);
  }
}

.demoItem {
  width: 800px;
  height: 500px;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-size: 100% 100%;
  background-color: rgba(3, 15, 25, 0.8);
}

.demoClose{
  width: 30px;
  height: 30px;
  cursor: pointer;
  position: absolute;
  bottom: -70px;
  background-color: #FFD700;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #000;
  font-weight: bold;
  text-align: center;
  line-height: 30px;
}

.demoWarn {
  height: 80px;
  width: 100%;
  background: repeating-linear-gradient(
    45deg,
    #FFD700,
    #FFD700 15px,
    transparent 15px,
    transparent 30px
  );
}

.demoContent {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 20px;
  color: #FFD700;
  font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
}

.warnItem {
  font-size: 28px;
  margin-bottom: 25px;
  text-align: center;
}

.warnItem:first-child {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 35px;
}
</style>
